import type { SVGProps } from "react";

interface EventsIconProps extends SVGProps<SVGSVGElement> {
    stroke?: string;
    className?: string;
    width?: number;
    height?: number;
}

const EventsIcon: React.FC<EventsIconProps> = ({
    stroke = "white",
    className = "",
    width = 16,
    height = 16,
    ...props
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M4 6.26577C4 7.42212 4.49441 8.66659 5.86535 8.66659H8C8 7.99992 6.71353 5.64029 5.03346 5.34617C4.49247 5.25146 4 5.68967 4 6.26577Z"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 6.26577C12 7.42212 11.5056 8.66659 10.1347 8.66659H8C8 7.99992 9.28647 5.64029 10.9665 5.34617C11.5075 5.25146 12 5.68967 12 6.26577Z"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.3335 2.66675H2.66683C1.93045 2.66675 1.3335 3.2637 1.3335 4.00008V12.0001C1.3335 12.7365 1.93045 13.3334 2.66683 13.3334H13.3335C14.0699 13.3334 14.6668 12.7365 14.6668 12.0001V4.00008C14.6668 3.2637 14.0699 2.66675 13.3335 2.66675Z"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 2.66675V13.3334"
                stroke={stroke}
                strokeLinejoin="round"
            />
            <path
                d="M1.3335 8.66675H14.6668"
                stroke={stroke}
                strokeLinejoin="round"
            />
            <path
                d="M10 10.6667L8 8.66675L6 10.6667"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default EventsIcon; 